import React, { Component } from 'react'
import {FormFeedback, FormGroup, Label} from "reactstrap";

class File extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this)
    }

    onChange(e) {
        const { input: { onChange } } = this.props;
        onChange(e.target.files[0])
    }

    render() {
        const field = this.props;
        const { input: { value } } = this.props

        return (
            <FormGroup>
                <Label>{field.placeholder}</Label>
                <input className={field.meta.error && field.meta.touched ? 'is-invalid form-control' : 'form-control'}
                       type="file"
                       onChange={this.onChange}
                       style={{color: "#000000"}}
                />


                {field.meta.error && field.meta.touched && <FormFeedback className="invalid-feedback" style={{display: "block"}}>{field.meta.error}</FormFeedback>}

            </FormGroup>
        )
    }
}

export default File


// WEBPACK FOOTER //
// ./src/renderFile.js